const canvasWidth = 2000
const canvasHeight = 2800
const imageWidth = 346
const imageHeight = 244
const imagePositions = [[1014, 858], [1014, 1128], [1014, 1398], [1014, 1668]]

const backgroundUrl = "/levite/_background.png"

let backgroundImage;
const fallbackBackground = () => {
    if (!backgroundImage) {
        backgroundImage = new Image();
        backgroundImage.src = backgroundUrl;
    }
    return backgroundImage;
}

const whenLoaded = (img) => img.complete ? null : new Promise((resolve) => {
    img.addEventListener('load', resolve, { once: true })
    img.addEventListener('error', resolve, { once: true })
})

window.customElements.define(
    "levite-chair-render",
    class LeviteChairRender extends HTMLElement {
        connectedCallback() {
            if (!this._output) {
                this._canvas = document.createElement('canvas')
                this._canvas.width = canvasWidth
                this._canvas.height = canvasHeight

                this._output = document.createElement('a')
                this._output.download = "Ihr Levitenstuhl.png"
                this.appendChild(this._output)
            }

            this.renderSelection()
        }

        constructor() {
            super()
            this._selection = []
        }

        set selection(selection) {
            // two arrays are never the same in js
            if (JSON.stringify(this._selection) === JSON.stringify(selection)) {
                return
            }
            this._selection = selection

            this.renderSelection()
        }

        renderSelection() {
            if (!this._canvas || !this._output) return;

            const background = document.getElementById('levite-chair-background') || fallbackBackground()
            const pictures = this._selection
                .slice(0, imagePositions.length)
                .map((val) => document.getElementById(val))
            const images = [background, ...pictures].filter((img) => img)

            const renderId = this._renderId = (this._renderId || 0) + 1

            Promise.all(images.map(whenLoaded))
                .then(() => {
                    if (renderId !== this._renderId || !this.isConnected) return;
                    this.draw(background, pictures)
                })
        }

        draw(background, pictures) {
            const ctx = this._canvas.getContext("2d")
            const isDrawable = (img) => img && img.complete && img.naturalWidth > 0

            ctx.clearRect(0, 0, canvasWidth, canvasHeight)

            if (isDrawable(background)) {
                ctx.drawImage(background, 0, 0, canvasWidth, canvasHeight)
            }

            pictures.forEach((img, idx) => {
                if (!isDrawable(img)) return;
                ctx.drawImage(img, imagePositions[idx][0], imagePositions[idx][1], imageWidth, imageHeight)
            })

            const url = this._canvas.toDataURL("image/png")

            const image = new Image()
            image.src = url;

            this._output.href = url.replace("image/png", "image/octet-stream")
            this._output.innerHTML = image.outerHTML

            setTimeout(() => {
                this._output.scrollIntoView({ block: "end", behavior: "smooth" })
            }, 100)
        }
    }
);
